import * as React from 'react'
import { Modal } from 'antd'
import { FormattedMessage } from 'react-intl'
import { useDispatch, useSelector } from 'react-redux'
import { flow, pipe } from 'fp-ts/lib/function'
import { closeViewPayerAction } from './types'
import { option, array } from 'fp-ts'
import { memoed } from '@library/react-toolkit'
import { ShowPayer } from './ShowPayer'

const ViewPayerModal = () => {
  const payer = useSelector(s =>
    pipe(
      s.payers.selectedPayer,
      option.chain(id =>
        pipe(
          memoed.extract(s.payers.payers).data,
          array.findFirst(customer => customer.id === id)
        )
      ),
      option.toUndefined
    )
  )
  const dispatch = useDispatch()

  return (
    <Modal
      zIndex={2}
      visible={!!payer}
      onCancel={flow(closeViewPayerAction, dispatch)}
      title={<FormattedMessage id="viewCustomer" />}
      destroyOnClose={true}
      footer={null}
    >
      <ShowPayer
        payer={
          payer ?? {
            id: 0,
            name: '',
            email: '',
            address: '',
            taxNumber: '',
            phoneNumber: '',
            nymId: undefined,
          }
        }
      />
    </Modal>
  )
}

export default ViewPayerModal
